import { UTCDeliveryPeriod } from '@epicuro-next/ataraxia/models';
import {
  getDeliveryShopId,
  makeIntervalISODate,
} from '@epicuro-next/utilities';

import {
  BulkTypeDeliveryPeriod,
  BusinessState,
  DeliveryPeriodType,
} from '../../../models';
import { removeDateFromCacheReducer } from '../cache-delivery-periods/update-delivery-periods-cache.reducer';

export function deleteBulkDeliveryPeriodBusiness(
  state: BusinessState,
  { from, to }: UTCDeliveryPeriod,
): BusinessState {
  if (!from || !to) {
    return state;
  }

  const fromJson = from;
  const toJson = to;

  const deliveryShopId = getDeliveryShopId(state.activeDeliveryShop);
  const deliveryPeriodsByShop = state.deliveryPeriods[deliveryShopId] ?? {};
  const deliveryPeriodsByType =
    deliveryPeriodsByShop[DeliveryPeriodType.Bulk] ?? {};

  const filteredDeliveryPeriods = (
    deliveryPeriodsByType.deliveryPeriods ?? []
  ).filter(
    ({ from: existingFrom, to: existingTo }: BulkTypeDeliveryPeriod) =>
      !(existingFrom === fromJson && existingTo === toJson),
  );

  return {
    ...state,
    dirty: true,
    deliveryPeriods: {
      ...state.deliveryPeriods,
      [deliveryShopId]: {
        ...deliveryPeriodsByShop,
        [DeliveryPeriodType.Bulk]: {
          ...deliveryPeriodsByType,
          selectedDeliveryPeriod: filteredDeliveryPeriods[0] ?? null,
          deliveryPeriods: filteredDeliveryPeriods,
        },
      },
    },
    cached: removeDateFromCacheReducer(
      state.cached,
      makeIntervalISODate(fromJson, toJson),
    ),
  };
}
